import { MotifButton } from '@ey-xd/motif-wc-react';
import { useRouter } from '@tanstack/react-router';
import { resolveLegacyRouteTarget } from '@/router/legacy-route-adapter';
import { openPopupMfe } from '@/mfe/popup-store';

interface LegacyPopupFallbackPageProps {
  target: string;
}

export function LegacyPopupFallbackPage({ target }: LegacyPopupFallbackPageProps) {
  const router = useRouter();
  const resolution = resolveLegacyRouteTarget(target);

  const openFallback = () => {
    if (resolution.kind === 'popup') {
      openPopupMfe(resolution.appId, resolution.subPath);
      return;
    }
    if (resolution.kind === 'external') {
      window.open(resolution.url, '_blank', 'noopener,noreferrer');
      return;
    }
    void router.navigate({ to: resolution.path });
  };

  return (
    <section className="system-page" aria-labelledby="legacy-popup-title">
      <div className="system-page__panel">
        <h1 id="legacy-popup-title">App dialog unavailable</h1>
        <p>
          This legacy link opens in the Angular shell as a popup dialog. The React shell preserves
          the route and sends you to the closest supported destination for now.
        </p>
        <p className="system-page__muted">Target: {target}</p>
        {resolution.kind === 'internal' && resolution.reason ? (
          <p className="system-page__muted">{resolution.reason}</p>
        ) : null}
        <MotifButton onClick={openFallback}>Open supported destination</MotifButton>
      </div>
    </section>
  );
}
